import _ from 'lodash';
import * as types from './types';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

const INITIAL_STATE = {
  printWHKITHoldReportsLoading: false,
  printWHKITAvailabilityReportsLoading: false,
  printLoadingError: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.PRINT_WAREHOUSE_KITCHEN_HOLD_REPORTS_LOADING:
      return {
        ...state,
        printWHKITHoldReportsLoading: action.payload,
      };

    case types.PRINT_WAREHOUSE_KITCHEN_AVAI_REPORTS_LOADING:
      return {
        ...state,
        printWHKITAvailabilityReportsLoading: action.payload,
      };

    case types.PRINT_LOADING_ERROR:
      const printLoadingError = action.payload.response;
      if (
        _.has(printLoadingError, 'data.Errors') &&
        printLoadingError.data.Errors.length
      ) {
        return {
          ...state,
          printLoadingError: printLoadingError.data.Errors,
        };
      }
      return {
        ...state,
        printLoadingError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while printing Warehouse/Kitchen data. Please try again.',
        },
      };
    case types.CLEAR_PRINT_LOADING_ERROR:
      return {
        ...state,
        fetchWHKITListLoadingError: null,
        printLoadingError: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/warehousereport/state/reducers.js